import React from 'react';
import {
	LocalizationProvider,
	DesktopTimePicker,
	DesktopTimePickerProps,
} from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { TextField, TextFieldProps } from '@mui/material';
import moment from 'moment';

interface CustomTimePickerProps extends DesktopTimePickerProps<any, any> {
	id: string;
	name: string;
	error?: boolean;
	wrapperClass?: string;
	helperText: string;
	required: boolean;
	onChange: (time: unknown) => void;
}

export const CustomTimePicker = ({
	wrapperClass,
	value,
	onChange,
	label,
	helperText,
	...props
}: CustomTimePickerProps) => {
	const handleChange = (p: unknown) => onChange(p ? moment(p as Date) : null);

	const renderInput = (params: TextFieldProps) => (
		<TextField helperText={helperText} className={wrapperClass} {...params} />
	);

	return (
		<LocalizationProvider dateAdapter={AdapterDateFns}>
			<DesktopTimePicker
				{...props}
				ampm={false}
				label={label}
				onChange={handleChange}
				value={value}
				renderInput={renderInput}
				InputAdornmentProps={{
					position: 'start',
				}}
			/>
		</LocalizationProvider>
	);
};
